import styled from 'styled-components';
import { Card } from 'styles/Details';

export const Container = styled(Card)`
  font-size: 14px;
`;
